import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import React from 'react';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemDateReadMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	return (
		<ContentBlock
			title={t('labels.dateRead')}
			content={FormatLocaleDateTime(mailItemData?.dateRead as Date)}
			iconContent={{ icon: faCalendar, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemDateReadMeta };
